import React, { useEffect } from "react";
import { useTable, usePagination } from "react-table";

const DataTable = ({ columns, data, enablePagination = true }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    page,
    prepareRow,
    state,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setPageSize,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    usePagination
  );

  useEffect(() => {
    setPageSize(10);
  }, [setPageSize]);

  return (
    <>
      <table
        className="table table-bordered align-middle mb-0"
        {...getTableProps()}
      >
        <thead className="table-light">
          {headerGroups.map((hg) => (
            <tr {...hg.getHeaderGroupProps()}>
              {hg.headers.map((col) => (
                <th
                  {...col.getHeaderProps()}
                  className="sticky-top bg-light"
                >
                  {col.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {(enablePagination ? page : rows).length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="text-center">
                No records found
              </td>
            </tr>
          ) : (
            (enablePagination ? page : rows).map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()}>
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })
          )}
        </tbody>
      </table>

      {enablePagination && (
        <div className="d-flex justify-content-between align-items-center mt-2">
          <div>
            Showing {state.pageIndex * state.pageSize + 1} to{" "}
            {Math.min(
              (state.pageIndex + 1) * state.pageSize,
              data.length
            )}{" "}
            of {data.length} entries
          </div>

          <div>
            <button
              className="btn btn-sm btn-outline-secondary me-2"
              onClick={previousPage}
              disabled={!canPreviousPage}
            >
              Previous
            </button>
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={nextPage}
              disabled={!canNextPage}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default DataTable;
